<app-manager-dashboard
  *ngIf="user.role === roles.AgentRestricted || user.role === roles.AgentAll"></app-manager-dashboard>
<app-supervisor-dashboard
  *ngIf="user.role === roles.SystemAdmin || user.role === roles.ProgramAdmin"></app-supervisor-dashboard>
